(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial_grid_page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const testimonials = document.querySelectorAll('.testimonial-text-wrapper');

    testimonials.forEach((wrapper) => {
      const text = wrapper.querySelector('.testimonial-text');
      const button = wrapper.querySelector('.read-more-btn');

      // Create hidden clone to measure text height
      const clone = text.cloneNode(true);
      clone.style.display = 'block';
      clone.style.webkitLineClamp = 'unset';
      clone.style.lineClamp = 'unset';
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      wrapper.appendChild(clone);

      if (clone.scrollHeight > text.clientHeight + 5) {
        button.hidden = false;
      }
      wrapper.removeChild(clone);

      button.addEventListener('click', () => {
        text.classList.toggle('expanded');
        button.textContent = text.classList.contains('expanded') ? 'Read less' : 'Read more';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the_science_box"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.columns-section__content').forEach((content) => {
    const text = content.querySelector('.content-text').innerText.trim();

    // Split text by words to limit by approx 5 lines (~100-120 words)
    const words = text.split(' ');
    const visibleWords = words.slice(0, 50).join(' ');
    const hiddenWords = words.slice(50).join(' ');

    if (hiddenWords.length > 0) {
      content.querySelector('.content-text').innerText = visibleWords;
      content.querySelector('.more-text').innerText = hiddenWords;
    } else {
      content.querySelector('.read-more-btn').style.display = 'none';
      content.querySelector('.dots').style.display = 'none';
    }
  });

  document.querySelectorAll('.read-more-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const content = button.closest('.columns-section__content');
      const dots = content.querySelector('.dots');
      const moreText = content.querySelector('.more-text');
      const mainText = content.querySelector('.content-text');

      if (button.textContent === 'Read more') {
        dots.style.display = 'none';
        moreText.style.display = 'inline';
        button.textContent = ' Read less';
      } else {
        dots.style.display = 'inline';
        moreText.style.display = 'none';
        button.textContent = 'Read more';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
